const accessToken = ""
const user = { id: "", name: "", username: "", email: "", uuid: "" }
const params = {}
const place = {}
const roles = []
const hasLoadedOnce = false

export default {
    accessToken,
    user,
    params,
    place,
    roles,
    hasLoadedOnce,
};
